import React, { useEffect, useState } from 'react';
import { Calendar } from 'primereact/calendar';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { Accordion, AccordionTab } from 'primereact/accordion';
import calendarIcon from '../../assets/icons/calendar.svg';
// eslint-disable-next-line no-unused-vars
import HistoryItem from '../../components/user/HistoryItem';
import closeIcon from '../../assets/icons/closeIcon.svg';
import useWindowSize from '../../hooks/useWindowSize';
import { getHistory } from '../../store/actions/userAccount';
import Spinner from '../../components/Spinner';
import arrowUp from '../../assets/icons/arrow_down.svg';
import arrowUpBlue from '../../assets/icons/arrow_down_blue.svg';

function AccountHistory({ handleCloseMenu }) {
  const [query, setQuery] = useState('');
  const [date, setDate] = useState(null);
  const { width } = useWindowSize();
  const dispatch = useDispatch();
  const { loading, history } = useSelector((state) => state.userAccount);
  const lang = Cookies.get('i18next') || 'en';
  const { translations } = useSelector((state) => state.translation);
  // eslint-disable-next-line no-unused-vars
  const [filteredHistory, setFilteredHistory] = useState(history);
  useEffect(() => {
    setFilteredHistory(history);
  }, [history]);
  useEffect(() => {
    dispatch(getHistory());
  }, []);

  const handleSearch = (value) => {
    setQuery(value);
    if (value) {
      setFilteredHistory(
        history.filter((historyItem) => historyItem.services
          .some((service) => service.title.toLowerCase().includes(value.toLowerCase()))),
      );
    } else {
      setFilteredHistory(history);
    }
  };
  const handleDate = (value) => {
    setDate(value);
    setFilteredHistory(history.filter((historyItem) => new Date(historyItem.register.date)
      .toDateString()
        === value.toDateString()));
  };
  return (
    <div className="account__profile">
      <div className="account__profile-top">
        <div className="account__profile-top-mobile">
          <h2 className="account__profile-top-title">{translations.profile_history[lang]}</h2>
          {width < 768
                        && (
                        <button onClick={handleCloseMenu} type="button">
                          <img
                            className="account-close-icon"
                            src={closeIcon}
                            alt=""
                          />
                        </button>
                        )}
        </div>
      </div>
      <div className="account__profile-history-search-bar">
        <div className="account__profile-history-search-bar-input-block">
          <div className="account__profile-history-search-bar-input-block-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <g clipPath="url(#clip0_127_1493)">
                <circle cx="9.58463" cy="9.58329" r="7.91667" stroke="#384754" strokeWidth="1.5" />
                <path
                  d="M15.418 15.4166L18.3346 18.3333"
                  stroke="#384754"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_127_1493">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <input placeholder={translations.search_input[lang]} type="text" value={query} onChange={(e) => handleSearch(e.target.value)} />
        </div>
        <div className="account__profile-history-search-bar-date-block">
          <Calendar
            showIcon
            icon={() => (
              <img
                src={calendarIcon}
                alt="calendar"
                className="calendar-icon"
              />
            )}
            placeholder={translations.date[lang]}
            value={date}
            onChange={(e) => handleDate(e.value)}
            className="calendar user"
            inputClassName="calendar-input"
            panelClassName="calendar-panel"
            todayButtonClassName="calendar-today-button"
            clearButtonClassName="calendar-clear-button"
            id="date"
            selectionMode="single"
          />
        </div>
      </div>
      {!loading ? (
        <div className="account__profile-history-list">
          <Accordion
            collapseIcon={() => (
              <button className="accordion-collapse-btn" type="button">
                <img src={arrowUp} alt="arrow up" />
              </button>
            )}
            expandIcon={() => (
              <button className="accordion-expand-btn" type="button">
                <img src={arrowUpBlue} alt="arrow up" />
              </button>
            )}
            style={{ marginTop: 0 }}
            className="faq__accordion"
          >
            {filteredHistory.map((item) => (
              // eslint-disable-next-line react/jsx-no-undef
              <AccordionTab
                key={item.register.id}
                contentClassName="account-accordion-content"
                className="accordion-tab"
                headerClassName="accordion-header"
                    // header={item.points}
                headerTemplate={() => (
                  <div className="account-accordion-header">
                    <p className="account-accordion-header-enumeration">
                      {translations.order[lang]}
                      {' '}
                      {item.register.id}
                    </p>
                    {/* <div className="account-accordion-header-bonus"> */}
                    {/*  <p className="account-accordion-header-enumeration">
                    {translations.profile_bonuses[lang]}</p> */}
                    {/*  <p className="bonus-quantity received"> */}
                    {/*    +*/}
                    {/*    {item.register.received_bonus} */}
                    {/*  </p> */}
                    {/*  <p className="bonus-quantity used"> */}
                    {/*    -*/}
                    {/*    {item.register.used_bonus} */}
                    {/*  </p> */}
                    {/* </div> */}
                  </div>
                )}
              >
                <div className="history-details">
                  <h2 className="account-accordion-header-enumeration">{translations.details[lang]}</h2>
                  <div>
                    <div className="history-item-info-item">
                      <p className="history-item-info-item-title">{translations.branch[lang]}</p>
                      <p className="history-item-info-item-value">{item.register.branch}</p>
                    </div>
                    <div className="history-item-info-item">
                      <p className="history-item-info-item-title">{translations.date[lang]}</p>
                      <p className="history-item-info-item-value">{item.register.date}</p>
                    </div>
                    <div className="history-item-info-item">
                      <p className="history-item-info-item-title">{translations.status[lang]}</p>
                      <p className={`history-item-info-item-value status ${item.register.status === 'Successful' ? 'done' : 'pending'}`}>{item.register.status}</p>
                    </div>
                    <div className="history-item-info-item">
                      <p className="history-item-info-item-title">{translations.payment_type[lang]}</p>
                      <p className="history-item-info-item-value">{item.register.payment_type === 'vPos' ? translations.vPos[lang] : translations.cash[lang]}</p>
                    </div>
                  </div>
                </div>
                <div className="history-services">
                  <h2 className="account-accordion-header-enumeration history">{translations.services[lang]}</h2>
                  <div className="history-services-list">
                    {item.services.map((service) => (
                      <HistoryItem
                        key={service.id}
                        title={service.title}
                        price={service.price}
                      />
                    ))}
                  </div>
                </div>
              </AccordionTab>

            ))}
          </Accordion>
          {/* {filteredHistory.map((historyItem) => ( */}
          {/*  historyItem.services.map((service) => ( */}
          {/*    <HistoryItem */}
          {/*      key={service.id} */}
          {/*      title={service.title} */}
          {/*      price={service.price} */}
          {/*      branch={historyItem.register.branch} */}
          {/*      date={`${historyItem.register.date || ''}${historyItem.register.time || ''}`} */}
          {/*      bonus="chyka" */}
          {/*      status={historyItem.register.status} */}
          {/*      doctor="chyka" */}
          {/*    /> */}
          {/*  )) */}
          {/* ))} */}
        </div>
      ) : <Spinner width={100} height={100} />}
    </div>
  );
}

export default AccountHistory;
